module.exports = __webpack_public_path__ + "static/media/2.b7a83e5a.chunk.js.LICENSE.faba0362.txt";